import { render, staticRenderFns } from "./AjaxLoader.vue?vue&type=template&id=d76a4876&"
import script from "./AjaxLoader.vue?vue&type=script&lang=ts&"
export * from "./AjaxLoader.vue?vue&type=script&lang=ts&"
import style0 from "./AjaxLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports